import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {Color} from 'ng2-charts';
import {ChartOptions} from 'chart.js';
import {MatOption} from '@angular/material';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ConfService} from '../../conf.service';
import {Email} from '../journey-analytics.component';
import {AuthedApiService} from '../../authed-api.service';
import {environment} from '../../../environments/environment';
import {AccountInfoService} from '../../user/account-info.service';

@Component({
  selector: 'app-journey-dashboard',
  templateUrl: './journey-dashboard.component.html',
  styleUrls: ['./journey-dashboard.component.scss']
})
export class JourneyDashboardComponent implements OnInit {


  showNextPanel = true;
  ////
  ////
  currentSession: string;
  sessionLogs = {};
  noOfSessions = 0;
  sessionIds = [];
  sessionList = [];
  currentSessionLog: any;
  componentLoading = true;
  dataLoading = false;
  users = [];
  apiActions = 0;
  apisCreated = 0;

  hasJourneyPermission = true;
  hasAllPartnerPermission = true;
  hasAllEnvironmentPermission = true;
  hasAllUserPermission = false;

  partners = [];
  partnerEnvironments = {};
  partnerEnvironmentEmails: any;
  partnerInput = '';
  environmentInput = '';
  userEmailInput = [];
  currentEnvInputs = [];

  settings = {
    text: 'Select API Method Types *',
    // selectAllText: 'Select All',
    // unSelectAllText: 'Unselect All',
    enableSearchFilter: true,
    autoPosition: false
  };
  // methodType: string;
  userEmails: Email[] = [
    {id: 'GET', itemName: 'GET'},
    {id: 'PUT', itemName: 'PUT'},
    {id: 'POST', itemName: 'POST'},
    {id: 'DELETE', itemName: 'DELETE'},
    {id: 'PATCH', itemName: 'PATCH'}
  ];

  selectedUserEmails = [
  ];

  @ViewChild('allSelected') private allSelected: MatOption;
  searchUserForm: FormGroup;

  isRetrieving = false;
  isData = false;
  errorToBeDisplayed = {title: '', subTitle: ''};

  currentEnvironment = localStorage.getItem('partner');
  currentUser = localStorage.getItem('signInEmail');


  @Input() hasPartnerSelectPermission = true;
  @Input() hasEnvironmentSelectPermission = true;
  @Input() hasUserSelectpermission = true;


  constructor(private confPost: ConfService, public platform: LeftpanelComponent, private fb: FormBuilder, private authedApi: AuthedApiService,
  private accountInfoService: AccountInfoService) {

  }

  ngOnInit() {
    this.searchUserForm = this.fb.group({
      userType: new FormControl('')
    });

    const partner = localStorage.getItem('partner').split('-');
    const partnerName = partner.length === 1 ? partner[0] : partner[1];

    if (this.hasPartnerSelectPermission || this.hasEnvironmentSelectPermission || this.hasUserSelectpermission) {
      let queryString = 'partner.regex=admin';

      if (!this.hasPartnerSelectPermission && this.hasEnvironmentSelectPermission) {
        queryString += '&account=admin-' + partnerName;
        this.partnerInput = partnerName;
      }

      if (!this.hasPartnerSelectPermission && !this.hasEnvironmentSelectPermission) {
        this.partnerInput = partnerName;
        this.environmentInput = this.currentEnvironment;
        this.partnerEnvironments[this.partnerInput] = [this.environmentInput];
        this.setUsersForEnvironemnt(this.environmentInput);
        this.componentLoading = false;
      } else {
        this.confPost.getSettingsV2(queryString + '&fields=account,environments.name').subscribe(response => {
          if (response) {
            this.setPartnerData(response);
            this.componentLoading = false;
          }
        }, error => {
          this.platform.handleErrorGracefully(error, 'Unable to retrieve partner info.');
        });
      }

    } else {
      this.partnerInput = partnerName;
      this.environmentInput = this.currentEnvironment;
      this.retrieveSessionsData( false);
    }

    // window.addEventListener('resize', this.docResize);

  }

  setUsersForEnvironemnt (environment) {
    this.partnerEnvironmentEmails = [];
    this.userEmailInput = [];
    this.confPost.getData('access', 'access', 'v1', 'users', 'environments.name=' + environment + '&fields=email').subscribe(response => {
      if (response) {
        // this.partnerEnvironmentEmails = response;
        this.setUser(response);
      }
    }, error => {
      this.platform.handleErrorGracefully(error, 'Unable to retrieve partner info.');
    });
  }

  setUser(response) {
    this.selectedUserEmails = [];
    response.forEach((value, index) => {
      this.selectedUserEmails.push({key: index + 1, value: value.email});
    });
  }

  setAnalyticsdata(response) {

    if (response.length > 0) {
      this.isData = true;
      this.errorToBeDisplayed.title = '';
    } else {
      this.errorToBeDisplayed.title = 'Data not found.';
      this.isData = false;
    }
    this.apiActions = 0;
    this.apisCreated = 0;


    for (const session of response) {
        this.apiActions = session['action']['resource'] === 'DEPLOY' || session['action']['resource'] === 'REDEPLOY' ? ++this.apiActions : this.apiActions;
        this.apisCreated = session['action']['resource'] === 'DEPLOY' && session['action']['result'] === 'SUCCESS' ? ++this.apisCreated : this.apisCreated;
    }
    // this.sessionLogs = currentSessionLogs;
    // this.noOfSessions = currentSessionIds.length;
    // this.sessionIds = currentSessionIds;
    this.dataLoading = false;
    this.componentLoading = false;
    // if (this.sessionIds.length > 0) {
    //   this.setSession(this.sessionIds[0]['sessionId']);
    // }
  }

  setPartnerData(response) {
    for (const val of response) {
      if (val.account) {
        const partner = val.account.split('-');
        const partnername = partner.length === 2 ? partner[1] : partner[0];
        this.partners.push(partnername);

        if (val.environments) {
          for (const environment of val.environments) {
            if (this.partnerEnvironments[partnername]) {
              this.partnerEnvironments[partnername].push(environment.name);
            } else {
              this.partnerEnvironments[partnername] = [environment.name];
            }
          }
        }
      }
    }
  }

  retrieveSessionsData(isFromSelectableList = true) {
    if (this.partnerInput.length && this.environmentInput.length && (!isFromSelectableList || (isFromSelectableList && this.userEmailInput.length))) {
      this.dataLoading = true;
      this.isRetrieving = true;
      this.errorToBeDisplayed.title = '';
      this.errorToBeDisplayed.subTitle = '';

      let queryString = 'partner=' + this.environmentInput;

      this.users = [];
      this.sessionIds = [];
      this.sessionList = [];
      this.noOfSessions = 0;
      this.apisCreated = 0;
      this.apiActions = 0;
      if (isFromSelectableList) {
        if (this.selectedUserEmails.length !== 0 && !this.selectedUserEmails.includes(0)) {
          const emailList = [];
          this.selectedUserEmails.forEach((value) => {
            if (value.key !== 0 && this.userEmailInput.includes(value.key)) {
              emailList.push(value.value);
            }
          });
          for (const email of emailList) {
            this.users.push(email);
            const params = { partner: this.environmentInput, email: email};
            this.authedApi.getCoreApi(environment.coreAPI.sessionsList.name, environment.coreAPI.sessionsList.version, '', params).subscribe(resp => {
              if (resp) {
                resp['sessionIDs'].sort((a, b) => b.startedAt - a.startedAt);
                for (const i of resp['sessionIDs']) {
                  this.sessionIds.push(i);
                  this.noOfSessions += 1;
                }
                this.sessionList = this.getSessionGroups(this.sessionIds);
              }
            });
          }
          const emails = emailList.join(',');
          queryString += '&email=' + emails;
        }
      } else {
        const params = { partner: this.environmentInput, email: this.currentUser};
        this.authedApi.getCoreApi(environment.coreAPI.sessionsList.name, environment.coreAPI.sessionsList.version, '', params).subscribe(resp => {
          if (resp) {
            // resp['sessionIDs'].sort((a, b) => b.startedAt - a.startedAt);
            for (const i of resp['sessionIDs']) {
              this.sessionIds.push(i);
              this.noOfSessions += 1;
            }
            this.sessionList = this.getSessionGroups(this.sessionIds);
          }
        });
        this.users.push(this.currentUser);
        queryString += '&email=' + this.currentUser;
      }

      this.confPost.getData('services', 'services', 'v3', 'auditLogs', queryString).subscribe(response => {
        this.setAnalyticsdata(response);
        this.isRetrieving = false;
      }, error => {
        this.dataLoading = false;
        this.componentLoading = false;
        this.isRetrieving = false;
        this.isData = false;
        this.errorToBeDisplayed.title = 'Unable to retrieve data';
        this.errorToBeDisplayed.subTitle = 'Please try again after some time.';
        this.platform.handleErrorGracefully(error, 'Unable to retrieve user logs.');
      });
    } else {
      this.platform.openSnackBar('Please fill all the required fields.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  setSession(sessionId) {
    this.showNextPanel = false;
    this.currentSession = sessionId;
    this.updateSession();
  }

  setEnvironments() {
    if (this.partnerEnvironments[this.partnerInput]) {
      this.currentEnvInputs = this.partnerEnvironments[this.partnerInput];
    }
  }

  updateSession() {
    // this.currentSessionLog = this.sessionLogs[this.currentSession];
    const params = { sessionId: this.currentSession};
    this.authedApi.getCoreApi(environment.coreAPI.sessionData.name, environment.coreAPI.sessionData.version, '', params).subscribe(resp => {
      if (resp) {
        this.currentSessionLog = resp;
        this.showNextPanel = true;
      }
    });
  }

  getTime(timeStamp) {
    if (timeStamp) {
      const date_ob = new Date(timeStamp);
      let hours = date_ob.getHours();
      const minutes = ('0' + date_ob.getMinutes()).slice(-2);
      const seconds = ('0' + date_ob.getSeconds()).slice(-2);
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12;


      return hours + ':' + minutes + ':' + seconds + ' ' + ampm;
    } else {
      return '-';
    }
  }

  getDayAndMonth(timeStamp) {
    if (timeStamp) {
      const date_ob = new Date(timeStamp);
      return date_ob.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    } else {
      return '-';
    }
  }
  getDay(startedAt: number): string {
    const date = new Date(startedAt * 1000); // Multiply by 1000 to convert to milliseconds
    const day = date.toLocaleDateString('en-US', { day: 'numeric' });
    return day;
  }

  getSessionGroups(sessionIds): any[] {
    const groups: { [key: string]: any[] } = {};

    for (const sessionId of sessionIds) {
      const day = this.getDayAndMonth(sessionId.startedAt);

      if (!groups[day]) {
        groups[day] = [];
      }

      groups[day].push(sessionId);
    }
    return Object.values(groups);
  }

  getCreatedDate(val) {
    if (val) {
      return this.platform.timeConverter(val);
    } else {
      return '-';
    }

  }

  tosslePerOne(all) {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return false;
    }
    if (this.searchUserForm.controls.userType.value.length === this.selectedUserEmails.length) {
      this.allSelected.select();
    }

  }
  toggleAllSelection() {
    if (this.allSelected.selected) {
      this.searchUserForm.controls.userType
          .patchValue([...this.selectedUserEmails.map(item => item.key), 0]);
    } else {
      this.searchUserForm.controls.userType.patchValue([]);
    }
  }


  console(sessionList: any) {
    // console.log('sessionList = ', sessionList);
  }

  handleSessionClick(event: Event, sessionId: string): void {
    event.preventDefault();
    this.setSession(sessionId);
  }

  toggleSelected(sessionId: any) {
    sessionId.selected = !sessionId.selected; // Add a 'selected' property to the session object
  }

}
